import { Redirect } from "react-router-dom";
import {
    ListCandidats,
    CandidatForm,
    FormUser,
    Listeruser,
    FormMission,
    Listermission,
    VisualiserCandidat,
    ContactList,
    VisualiserContact,
    ContactForm,
    VisualiserSociete,
    ListerSociete,
    FormSociete,
    Dashboard,
    visualisermission,
    Collaborateur,
    VisualiserCollaborateur,
    Demande
} from "./pages/index";
import ListSelections from "./pages/MesSelections/ListSelections";
import CandidatsListInSelection from "./pages/MesSelections/CandidatsListInSelection";
import CandidatTasks from "./pages/MesTaches/CandidatTasks";
import "./app.css";
import ContactTasks from "./pages/MesTaches/ContactTasks";
import EmailTypeList from "./pages/EmailType/EmailTypeList";
import EmailTypeForm from "./pages/EmailType/EmailTypeForm";
import CandidatsListInMission from "./pages/Mission/CandidatsListInMission";
import ScoredCandidates from "./pages/Mission/ScoredCandidates/ScoredCandidates";
import ShowCvCandidat from "./pages/Candidat/VisualiserCandidat/ShowCVCandidat";
import ReportingIntern from "./pages/reporting/reporting-intern/reporting-intern";
import PrivateRoute from "./PrivateRoute";
import Pilotage from "./pages/Pilotage";
import ProcessView from "./pages/Process/Process";
import DocumentsContrat from "./pages/DocumentsContrat/DocumentsContrat";
import { v4 } from "uuid";
import useFeatureFlags from "./hooks/useFeatureFlags";
import GestionConges from "./pages/Conge/GestionConges";
import TalentBoard from "./pages/TalentBoard/TalentBoard";
import Doublons from "./pages/Doublons/Doublons";
import CandidatsOffre from "./pages/Matching/CandidatsOffre";
import EntretienCandidat from "./pages/Matching/EntretienCandidat";
import MatchingCandidates from "./pages/Dashboard/Matching/MatchingCandidates";
import JobFitAnalysisPage from "./pages/Dashboard/Matching/JobFitAnalysisPage";
import GoMail from "./pages/GoMail/GoMail";
import Sourcing from "./pages/Sourcing/Sourcing";
import LinkedinLoginPage from "./pages/Sourcing/LinkedinLoginPage";


const PrivatesRoutes = ({ reset, setReset, snackbarShowMessage, setReloadNotifications, reloadNotifications }) => {
    const notAllowedRoles = ['ROLE_DELIVERY_MANAGER'];
    const { collaborate, documentContrat, conge } = useFeatureFlags();

    const routes = [
        {
            path: "/accueil",
            exact: true,
            component: () => (
                <Dashboard snackbarShowMessage={snackbarShowMessage} />
            ),
            notAllowedRoles
        },
        {
            path: "/accueil/chercher",
            exact: true,
            component: () => (
                <Dashboard snackbarShowMessage={snackbarShowMessage} />
            ),
            notAllowedRoles
        },
        {
            path: "/",
            exact: true,
            component: () => <Redirect to="/accueil" />,
            notAllowedRoles
        },
        {
            path: "/candidats-offre",
            exact: true,
            component: () => <CandidatsOffre />,
            notAllowedRoles
        },
        {
            path: "/candidats-offre/entretien",
            exact: true,
            component: () => <EntretienCandidat />,
            notAllowedRoles
        },

        {
            path: "/societe/:id/view",
            exact: true,
            component: () => <VisualiserSociete />,
            notAllowedRoles
        },
        {
            path: "/societe",
            exact: true,
            component: ListerSociete,
            notAllowedRoles,
        },
        {
            path: "/societe/add",
            exact: true,
            component: FormSociete,
            notAllowedRoles
        },
        {
            path: "/societe/:id/update",
            exact: true,
            component: () => <FormSociete editMode={true} />,
            notAllowedRoles
        },
        {
            path: "/candidats",
            exact: true,
            component: ListCandidats,
            notAllowedRoles
        },
        {
            path: "/candidats/:candidatId/job-fit/:jobId",
            exact: true,
            component: JobFitAnalysisPage,
            notAllowedRoles
        },
        {
            path: "/candidats/add",
            exact: true,
            component: CandidatForm,
            notAllowedRoles
        },
        {
            path: "/candidats/:idCandidat/edit",
            component: () => <CandidatForm snackbarShowMessage={snackbarShowMessage} editMode={true} />,
            notAllowedRoles
        },
        {
            path: "/candidats/:idCandidat/view",
            component: () => <VisualiserCandidat selected={true} />,
            notAllowedRoles
        },
        {
            path: "/societe/:id/missions/:missionId/view",
            exact: true,
            component: visualisermission,
            notAllowedRoles
        },
        {
            path: "/societe/:id/missions/:missionId/scoring",
            exact: true,
            component: ScoredCandidates,
            notAllowedRoles
        },
        {
            path: "/users/:id/update",
            exact: true,
            component: () => <FormUser editMode={true} />,
            notAllowedRoles
        },
        {
            path: "/societe/:id/missions/add",
            exact: true,
            component: FormMission,
            notAllowedRoles
        },
        {
            path: "/societe/:id/missions/:idMission/update",
            exact: true,
            component: () => <FormMission editMode={true} />,
            notAllowedRoles
        },
        {
            path: "/users/add",
            exact: true,
            component: FormUser,
            notAllowedRoles
        },
        {
            path: "/users",
            exact: true,
            component: Listeruser,
            notAllowedRoles
        },
        {
            path: "/candidats/cv/:pdfFileName",
            exact: true,
            component: ShowCvCandidat,
            notAllowedRoles
        },
        {
            path: "/contacts",
            exact: true,
            component: ContactList,
            notAllowedRoles
        },
        {
            path: "/selections",
            exact: true,
            component: ListSelections,
        },
        {
            path: "/societe/:id/contacts/:idContact/view",
            exact: true,
            component: () => <VisualiserContact snackbarShowMessage={snackbarShowMessage} />,
            notAllowedRoles
        },
        {
            path: "/societe/:id/contacts/:idContact/edit",
            exact: true,
            component: () => <ContactForm editMode={true} />,
            notAllowedRoles
        },
        {
            path: "/societe/:id/contacts/add",
            exact: true,
            component: () => <ContactForm />,
            notAllowedRoles
        },
        {
            path: "/process",
            exact: true,
            component: () => <ProcessView />,
            notAllowedRoles
        },
        {
            path: "/selections/:idSelection/candidats/list",
            exact: true,
            component: CandidatsListInSelection
        },
        {
            path: "/selections/:idSelection/candidats/:idCandidat/view",
            exact: true,
            component: () => <VisualiserCandidat selected={true} />,
        },
        {
            path: "/tachescandidat",
            exact: true,
            component: CandidatTasks,
            notAllowedRoles
        },
        {
            path: "/tachescontact",
            exact: true,
            component: ContactTasks,
            notAllowedRoles
        },
        {
            path: "/tachesclient",
            exact: true,
            component: () => <ContactTasks statut={"client"} />,
            notAllowedRoles
        },
        {
            path: "/tachesprospect",
            exact: true,
            component: () => <ContactTasks statut={"prospect"} />,
            notAllowedRoles
        },
        {
            path: "/emailtype",
            exact: true,
            component: () => <EmailTypeList />,
            allowedRoles: ["ROLE_TALENT_ACQUISITION_MANAGER"]
        },
        {
            path: "/emailtype/add",
            exact: true,
            component: () => <EmailTypeForm />,
            allowedRoles: ["ROLE_TALENT_ACQUISITION_MANAGER"]
        },
        {
            path: "/emailtype/:uuid/edit",
            exact: true,
            component: () => <EmailTypeForm editMode={true} />,
            allowedRoles: ["ROLE_TALENT_ACQUISITION_MANAGER"]
        },
        {
            path: "/missions",
            exact: true,
            component: () => <Listermission />,
            notAllowedRoles
        },
        collaborate && {
            path: "/collaborateurs",
            exact: true,
            component: () => <Collaborateur />,
            allowedRoles: ["ROLE_DIRECTION"]
        },

        collaborate && {
            path: "/collaborateurs/:id/view",
            exact: true,
            component: () => <VisualiserCollaborateur reloadNotifications={reloadNotifications} setReloadNotifications={setReloadNotifications} />,
            allowedRoles: ["ROLE_DIRECTION"]
        },
        {
            path: "/demandes",
            exact: true,
            component: () => <Demande />,
            allowedRoles: ["ROLE_DIRECTION"]
        },

        // {
        //     path: "/reportingClient",
        //     exact: true,
        //     component: () => <ReportingClient />,
        //     notAllowedRoles
        // },
        {
            path: "/pilotage",
            exact: true,
            component: () => <Pilotage />,
            notAllowedRoles
        },
        {
            path: "/reporting/intern",
            exact: true,
            component: () => <ReportingIntern />,
            notAllowedRoles
        },
        {
            path: "/candidats/missions/:idMission/list",
            exact: true,
            component: () => <CandidatsListInMission />,
            notAllowedRoles
        },
        documentContrat && {
            path: "/documents-contrat",
            exact: true,
            component: () => <DocumentsContrat />,
            allowedRoles: ["ROLE_DIRECTION"]
        },
        conge && {
            path: "/gestion-conge",
            exact: true,
            component: () => <GestionConges />,
            allowedRoles: ["ROLE_DIRECTION"]
        },
        {
            path: "/talent-board",
            exact: true,
            component: () => <TalentBoard />,
            notAllowedRoles
        },
        {
            path: "/doublons",
            exact: true,
            component: () => <Doublons />,
            notAllowedRoles
        },
        {
            path: "/matching-candidates",
            exact: true,
            component: () => <MatchingCandidates snackbarShowMessage={snackbarShowMessage} />,
            notAllowedRoles
        },
        {
            path: "/gomail",
            exact: true,
            component: () => <GoMail />,
            notAllowedRoles
        },
        {
            path: "/sourcing",
            exact: true,
            component: () => <Sourcing />,
            notAllowedRoles
        },
        {
            path: "/sourcing/connexion-linkedin",
            exact: true,
            component: () => <LinkedinLoginPage />,
            notAllowedRoles
        }

    ].filter(Boolean);

    return <>
        {routes.map((route, index) => (
            <PrivateRoute
                key={v4()}
                path={route.path}
                exact={route.exact}
                component={route.component}
                notAllowedRoles={route.notAllowedRoles ?? []}
            />
        ))}
    </>
}


export default PrivatesRoutes
